export enum ESpecificItem {
  notification,
  profile,
}

export enum ECategoryType {
  static,
  expandable,
}
